var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventsGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Offer Icon / events_gray") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707784",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E535C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Offer-Icon-/-events_gray",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33333333,8 L5.33333333,16 L18.6666667,16 L18.6666667,8 L5.33333333,8 Z M22,12 C22,10.8954264 22.8954264,10 24,10 L24,6 C24,4.89542643 23.1045736,4 22,4 L2,4 C0.895426432,4 0,4.89542643 0,6 L0,10 C1.10457357,10 2,10.8954264 2,12 C2,13.1045736 1.10457357,14 0,14 L0,18 C0,19.1045736 0.895426432,20 2,20 L22,20 C23.1045736,20 24,19.1045736 24,18 L24,14 C22.8954264,14 22,13.1045736 22,12 Z M20,7.66666667 L20,16.3333333 C20,16.8856201 19.5522868,17.3333333 19,17.3333333 L5,17.3333333 C4.44771322,17.3333333 4,16.8856201 4,16.3333333 L4,7.66666667 C4,7.11437988 4.44771322,6.66666667 5,6.66666667 L19,6.66666667 C19.5522868,6.66666667 20,7.11437988 20,7.66666667 Z",
    id: "icon",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsGray);
export default __webpack_public_path__ + "static/media/events_gray.2de6f626fe5cd7093ac8fce7b9a48684.svg";
export { ForwardRef as ReactComponent };